// @view/workspace/FeedbackSubmission.tsx

import React, { useState } from "react";
import * as styles from "@styles/Feedback.css";
import * as IO from "@ps-bridge/interop/io";

import { makeFeedbackContents } from "@ps-bridge/models/brands/feedbackContents";
import { makeFeedbackType } from "@ps-bridge/models/brands/feedbackType";
import type { FeedbackSubmissionViewProps } from "@ps-bridge/contracts/feedbackSubmission";
import FeedbackSuccessModalPanel from "@view/panels/workspace/FeedbackSuccessModal.panel";

const FeedbackSubmissionComponent: React.FC<FeedbackSubmissionViewProps> = ({
    feedbackContentsValue,
    successPhase,
    onFeedbackContentsChange,
    onSubmit,
    onCloseSuccessModal,
    onBackToHome,
}) => {
    const [category, setCategory] = useState<"Bug" | "FeatureRequest" | "General">("General");

    const isFormDisabled = feedbackContentsValue.length < 5;

    return (
        <div className={styles.container} data-testid="page-feedback" data-page-state="ready">
            <p className={styles.header}>Submit Your Feedback</p>
            <p className={styles.headertext}>Category:</p>
            <div className={styles.categoryPicker}>
                <select
                    className={styles.dropdownText}
                    data-testid="feedback-category"
                    value={category}
                    onChange={(event) => setCategory(event.target.value as "Bug" | "FeatureRequest" | "General")}
                >
                    <option value="General">General</option>
                    <option value="FeatureRequest">Feature Request</option>
                    <option value="Bug">Bug</option>
                </select>
            </div>

            <textarea
                className={styles.input}
                data-testid="feedback-contents"
                value={feedbackContentsValue}
                onChange={(event) => IO.run(onFeedbackContentsChange(event.target.value))}
                placeholder="Type your feedback here..."
            />

            <button
                data-testid="feedback-submit"
                disabled={isFormDisabled}
                className={isFormDisabled ? styles.disabledButton : styles.button}
                onClick={() => {
                    const request = {
                        feedback: makeFeedbackContents(feedbackContentsValue),
                        type: makeFeedbackType(category),
                    };
                    IO.run(onSubmit(request));
                }}
            >
                <span className={styles.buttonText}>Submit Feedback</span>
            </button>

            <FeedbackSuccessModalPanel
                phase={successPhase}
                onBackToHome={onBackToHome}
                onCloseSuccessModal={onCloseSuccessModal}
            />
        </div>
    );
};

export default FeedbackSubmissionComponent;
